import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { HomeroomUpdateRequest } from "./HomeroomUpdateRequest";

@Injectable()
export class DataService_HomeroomSetup {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	LoadHomeroom(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/LoadHomeroom?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadAcademy(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/LoadAcademy?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadStaff(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/LoadStaff?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	HomeroomUpdate(parms: HomeroomUpdateRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/HomeroomUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
